import $ from 'jquery';
import RevealWhenVisible from '../../components/reveal-when-visible';
import MilestoneSlider from './components/milestone-slider';
import NewsSlider from './components/news-slider';
$(() => {
    RevealWhenVisible.init();
    NewsSlider.init();
    MilestoneSlider.init();
});
